var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._g(_vm._b({staticStyle:{"padding":"0 0 0 0"},on:{"click":function($event){return _vm.wellClick($event)}}},'v-btn',_vm.attrs,false),_vm.on),[_c('span',[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }